/**
 * Blog Product Click Tracking for Just Perfume
 * 
 * Fires a blog_product_click event via the site's existing GA4 / dataLayer
 * whenever a reader clicks a product or collection link inside a blog article.
 *
 * INSTALLATION:
 * Add this script to your Shopify theme's blog article template, or include it
 * via Shopify's "Additional scripts" / theme.liquid, wrapped in a condition that
 * only loads on blog pages:
 *
 *   {% if template contains 'article' %}
 *   <script src="{{ 'blog-product-tracking.js' | asset_url }}" defer></script>
 *   {% endif %}
 *
 * Alternatively, paste the contents into a Shopify Custom Pixel or
 * Customer Events script if you prefer that approach.
 *
 * REQUIREMENTS:
 * - Links in blog content must have class="jp-product-link" and
 *   data-link-position="[position]" attributes (the upgraded blog generator
 *   adds these automatically).
 * - The site must have Google Tag Manager or gtag.js loaded (standard for
 *   GA4). If neither is present, the event is logged to console instead.
 * - Navigation always works even if tracking fails or is blocked.
 */
(function() {
  'use strict';

  // Gather blog context from the current page
  var blogTitle = '';
  var blogSlug = '';
  var blogPath = window.location.pathname || '';

  // Try to get the article title from the page
  var h1 = document.querySelector('article h1, .article-title, h1.blog-title, h1');
  if (h1) blogTitle = h1.textContent.trim();

  // Extract slug from URL path (e.g. /blogs/news/best-spring-perfumes -> best-spring-perfumes)
  var pathParts = blogPath.split('/').filter(Boolean);
  if (pathParts.length >= 3 && pathParts[0] === 'blogs') {
    blogSlug = pathParts[pathParts.length - 1];
  }

  /**
   * Fire the blog_product_click event
   */
  function trackClick(linkEl) {
    var href = linkEl.getAttribute('href') || '';
    var position = linkEl.getAttribute('data-link-position') || 'unknown';
    var linkText = linkEl.textContent.trim();

    // Determine destination type
    var destType = 'product';
    if (href.indexOf('/collections/') !== -1) destType = 'collection';
    else if (href.indexOf('#klaviyo') !== -1 || linkEl.classList.contains('jp-signup-link')) destType = 'email_signup';

    // Extract product info from the link or surrounding context
    var productHandle = '';
    var productTitle = linkText;
    var brand = '';

    // Try to get product handle from URL
    if (href.indexOf('/search?q=') !== -1) {
      productHandle = href.split('q=')[1] || '';
      productHandle = decodeURIComponent(productHandle).replace(/\+/g, ' ');
    } else if (href.indexOf('/products/') !== -1) {
      productHandle = href.split('/products/')[1] || '';
      productHandle = productHandle.split('?')[0].split('#')[0];
    }

    // Destination path (relative)
    var destPath = href;
    try {
      var url = new URL(href, window.location.origin);
      destPath = url.pathname + url.search;
    } catch(e) {
      // Keep href as-is
    }

    var eventData = {
      event: 'blog_product_click',
      blog_title: blogTitle,
      blog_path: blogPath,
      blog_slug: blogSlug,
      destination_path: destPath,
      destination_type: destType,
      product_handle: productHandle,
      product_title: productTitle,
      brand: brand,
      link_position: position
    };

    // Fire via dataLayer (GTM) if available
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      window.dataLayer.push(eventData);
    }
    // Also fire via gtag if available (direct GA4)
    else if (typeof window.gtag === 'function') {
      window.gtag('event', 'blog_product_click', {
        blog_title: eventData.blog_title,
        blog_path: eventData.blog_path,
        blog_slug: eventData.blog_slug,
        destination_path: eventData.destination_path,
        destination_type: eventData.destination_type,
        product_handle: eventData.product_handle,
        product_title: eventData.product_title,
        link_position: eventData.link_position
      });
    }
    // Fallback: log to console for debugging
    else {
      console.log('[JP Blog Tracking]', eventData);
    }
  }

  /**
   * Attach click listeners to all product links in the blog content.
   * Uses event delegation on the article container for efficiency.
   */
  function init() {
    // Find the blog article content area
    var article = document.querySelector('article, .article-content, .blog-content, .shopify-section--article');
    if (!article) {
      // Fallback: listen on the whole document
      article = document.body;
    }

    article.addEventListener('click', function(e) {
      // Find the closest jp-product-link or jp-signup-link
      var link = e.target.closest('.jp-product-link, .jp-signup-link');
      if (!link) return;

      // Track the click (non-blocking, never prevents navigation)
      try {
        trackClick(link);
      } catch(err) {
        // Tracking must never break navigation
        console.warn('[JP Blog Tracking] Error:', err);
      }
    });
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();